import { cn } from '@/lib/utils';
import { Tooltip } from '@/libs/components/src/lib/Tooltip';
import React, { useMemo } from 'react';
import Dropdown from '../../../../common/Dropdown';

type Props = {
  colHeading: { text: string; normalDefaultValue: string };
  rowHeading: string;
  tdChoice: { [key: string]: { text: string }[] };
  value: { choice: string; explanation?: string };
  abbreviations?: { [key: string]: string };
  i: number;
  onChange: (val: string) => void;
};

const EditableChartCell: React.FC<Props> = ({
  value,
  colHeading,
  rowHeading,
  tdChoice,
  abbreviations,
  i,
  onChange,
}) => {
  const options = useMemo(() => {
    return (
      tdChoice[colHeading.text]?.map(item => {
        return {
          text: item.text,
          onClick: () => {
            onChange(item.text);
          },
        };
      }) || []
    );
  }, [tdChoice, colHeading, onChange]);
  const notAssessed = value?.choice === 'Not assessed' || !value?.choice;

  return (
    <Dropdown
      displayLeft={i === 0}
      key={`${rowHeading}${colHeading}`}
      options={options}
      buttonClassName={cn('w-full', notAssessed ? 'min-w-[50px] hover:bg-gray-50/80' : '')}
      clickableElement={
        <div
          className={[
            value?.choice === colHeading?.normalDefaultValue ? 'text-primary-600' : 'text-red-500',
            'w-full text-center',
          ].join(' ')}
        >
          {notAssessed ? (
            <>&nbsp;</>
          ) : (
            <>
              {abbreviations?.[value?.choice] || value?.choice}{' '}
              {value?.choice === 'Other' && value?.explanation && (
                <span className="flex justify-center ml-20 -mt-6">
                  <Tooltip content={value?.explanation}>
                    <svg
                      className="shrink-0 mr-1.5 h-5 w-5 text-gray-400 hover:text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      id={`${rowHeading}${colHeading}`}
                    >
                      <path
                        fillRule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </Tooltip>
                </span>
              )}
            </>
          )}
        </div>
      }
    />
  );
};

export default EditableChartCell;
